import { InputField } from 'components/InputField';
import { LabelField } from "components/LabelField";
import React from 'react';
import { Col, Row } from 'react-bootstrap';

const AuthorizeForm = ({ formik,disabled }) => {
  return (
    <Row>
      <Col className="col-sm-6">
        <LabelField title="API login id" mandatory hint="Your Authorize.net merchant login ID, found in your Authorize.net dashboard under API Credentials. Required together with the Transaction key." />
        <InputField
          type="password"
          mandatory={true}
          {...{
            formik,
            title: 'none',
            formStyle: { marginBottom: 0 },
            name: 'api_login_id',
            placeholder: 'API login id',
            checkValidation: true,
          }}
          value={disabled ? "...................." : formik.values?.authorize?.api_login_id}
          handleChange={(e) => {
            formik.setFieldValue('authorize.api_login_id', e.target?.value);
          }}
          autoComplete="new-password"
        />
      </Col>
      <Col className="col-sm-6" >
        <LabelField title="Transaction key" mandatory hint="Your Authorize.net transaction signing key, found alongside the API login id in your Authorize.net dashboard. Both are required to process payments." />
        <InputField
          type="password"
          mandatory={true}
          {...{
            formik,
            title: "none",
            formStyle: { marginBottom: 0 },
            name: "transaction_key",
            placeholder: "Transaction key",
            checkValidation: true,
          }}
          value={disabled ? "...................." : formik.values?.authorize?.transaction_key}
          handleChange={(e) => {
            formik.setFieldValue('authorize.transaction_key', e.target?.value);
          }}
          autoComplete="new-password"
        />
      </Col>
    </Row>
  )
}

export default AuthorizeForm